module.exports = __webpack_public_path__ + "img/sprite-flags-24x24.7ed12ca4.png";